import { SvbrgAgentId } from '@/generated/gql/graphql';

export const FILE_UPLOAD_ENABLED_AGENT_IDS: Record<SvbrgAgentId, boolean> = {
  [SvbrgAgentId.quoteComparisonAgent]: true,
  [SvbrgAgentId.contractComparisonAgent]: true,
  [SvbrgAgentId.policyCheckerAgent]: true,
  [SvbrgAgentId.sourcerAgent]: true,
  [SvbrgAgentId.catalogueSearchAgent]: false,
  [SvbrgAgentId.companyGraphSupplierSearchAgent]: false,
  [SvbrgAgentId.frontdeskAgent]: false,
  [SvbrgAgentId.buyerAssistant]: false,
  [SvbrgAgentId.requesterAssistant]: false,
  [SvbrgAgentId.procurementItemsAgent]: false,
  [SvbrgAgentId.procurementKnowledgeAgent]: false,
  [SvbrgAgentId.webSearchAgent]: false,
  [SvbrgAgentId.conversationalAgent]: false,
};
